import React from "react";
import PropTypes from "prop-types";
import ReactModal from "react-modal";
import { useTranslation } from "react-i18next";
import ConfirmModal from "components/Modal/types/ConfirmModal";

/**
 * Popup para cerrar el onboarding.
 *
 * `complete`: el usuario acaba de marcar (o ya tiene) todos los pasos.
 * `incomplete`: quiere cerrarlo sin haber marcado los 6.
 */
const OnboardingCloseModal = ({
	isOpen,
	variant = "incomplete",
	total = 6,
	onCancel,
	onConfirm,
	isLoading = false,
}) => {
	const { t } = useTranslation();
	const isComplete = variant === "complete";

	return (
		<ReactModal
			isOpen={isOpen}
			onRequestClose={onCancel}
			ariaHideApp={false}
			overlayClassName="modal fade show"
			bodyOpenClassName="modal-open"
			className="modal-dialog modal-dialog-centered"
			shouldCloseOnOverlayClick={!isLoading}
		>
			<ConfirmModal
				title={t(
					isComplete
						? "onboarding.close.completeTitle"
						: "onboarding.close.incompleteTitle"
				)}
				message={t(
					isComplete
						? "onboarding.close.completeMessage"
						: "onboarding.close.incompleteMessage",
					{ total }
				)}
				style={{ width: "360px" }}
				confirmText={t("onboarding.close.confirm")}
				cancelText={
					isComplete
						? t("onboarding.close.keepOpen")
						: t("common.cancel")
				}
				closeModal={onCancel}
				confirmAction={onConfirm}
				isLoading={isLoading}
			/>
		</ReactModal>
	);
};

OnboardingCloseModal.propTypes = {
	isOpen: PropTypes.bool,
	variant: PropTypes.oneOf(["complete", "incomplete"]),
	total: PropTypes.number,
	onCancel: PropTypes.func,
	onConfirm: PropTypes.func,
	isLoading: PropTypes.bool,
};

export default OnboardingCloseModal;
